export default function goBack() {
	history.back()
}


// WEBPACK FOOTER //
// ./src/util/goBack.js